var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col justify-between flex-grow gap-2",
      style: { height: "calc(100%)" }
    },
    [
      _c(
        "div",
        {
          staticClass: "relative flex flex-col",
          style: { height: "calc(100%)" }
        },
        [
          !_vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-wrap items-center justify-center gap-1 pb-2",
                  attrs: {
                    id:
                      "sbt-ratio-" +
                      _vm.measurement.id +
                      "-" +
                      JSON.stringify(_vm.currentTrial)
                  }
                },
                _vm._l(_vm.ratioScores, function(taskCode) {
                  return _c(
                    "div",
                    {
                      key: taskCode.id,
                      staticClass:
                        "relative flex flex-col-reverse items-center overflow-hidden transition-all duration-300 border rounded",
                      class: {
                        "w-7.5 h-7.5": _vm.sessionStatus === "draft",
                        "w-10 h-10": _vm.sessionStatus !== "draft",
                        "bg-slate-200 border-slate-200": taskCode.count <= 0,
                        "bg-teal-100 border-teal-100": taskCode.count >= 1,
                        "bg-teal-100 border-teal-700":
                          taskCode.id === _vm.currentTrial.target_task_id
                      }
                    },
                    [
                      _vm._l(taskCode.ratios, function(ratio, idx) {
                        return _c("div", { key: idx }, [
                          ratio.prompt_id
                            ? _c(
                                "div",
                                {
                                  staticClass: "relative w-10 bg-teal-300",
                                  style: {
                                    height: 2.5 / taskCode.max_ratio + "rem"
                                  }
                                },
                                [
                                  ratio.target_problem_behavior_id
                                    ? _c("div", {
                                        staticClass:
                                          "absolute top-0 right-0 h-full bg-tomato-600",
                                        style: { width: "0.3125rem" }
                                      })
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "absolute left-0 w-full font-bold text-center",
                          class: {
                            "text-slate-600": taskCode.count === 0,
                            "text-teal-700":
                              taskCode.count > 0 ||
                              taskCode.id === _vm.currentTrial.target_task_id
                          },
                          style: {
                            fontSize:
                              _vm.sessionStatus === "draft"
                                ? "0.5rem"
                                : "0.625rem",
                            top: "50%",
                            transform: "translateY(-50%)"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isOpenTrialHistory
                                  ? taskCode.average + "%"
                                  : taskCode.code
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isOpenTrialHistory || _vm.isOpenEditTrial
            ? _c("div", { staticClass: "flex flex-col h-full" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-between flex-shrink-0 h-9"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-1" },
                      [
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-slate-700",
                              attrs: { text: "Current" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-teal-800",
                              attrs: {
                                text: _vm.currentTrialData.task_code.code
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.display === "select-next-task" &&
                        !_vm.isOpenEditTrial
                          ? _c(
                              "div",
                              [
                                _c("BlTextSubtitle3", {
                                  staticClass: "text-teal-800",
                                  attrs: {
                                    text:
                                      "| " + _vm.currentTrialData.average + "%"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.display === "select-prompt" && !_vm.isOpenEditTrial
                          ? _c("BlIcon", {
                              staticClass: "w-4 h-4",
                              attrs: {
                                icon: "edit",
                                color: "teal-7",
                                clickable: ""
                              },
                              on: { clicked: _vm.onUndoTrial }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-1" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Trial" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          staticClass: "text-teal-800",
                          attrs: { text: _vm.currentTrial.key }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isOpenProblemBehavior
                  ? _c("div", { staticClass: "h-full" }, [
                      _vm.display === "select-prompt"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col items-center content-center justify-center h-full gap-2"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex w-full gap-4 pb-4 overflow-x-auto scrolling-touch snap-x-mandatory scrollbar-lg",
                                  class: {
                                    "max-w-56": _vm.sessionStatus === "draft",
                                    "max-w-72": _vm.sessionStatus !== "draft"
                                  },
                                  attrs: {
                                    id: "sbt-scroll-" + _vm.measurement.id,
                                    dir: "ltr"
                                  },
                                  on: { scroll: _vm.onScroll }
                                },
                                _vm._l(_vm.promptBoxesPages, function(
                                  promptBoxes,
                                  idx
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key:
                                        _vm.measurement.id +
                                        "-sbt-prompt-boxes-" +
                                        (idx + 1),
                                      staticClass:
                                        "flex justify-center flex-shrink-0 w-full snap-center",
                                      attrs: {
                                        id:
                                          _vm.measurement.id +
                                          "-sbt-prompt-boxes-" +
                                          (idx + 1)
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-wrap items-start content-center justify-center w-full gap-x-2 gap-y-3",
                                          class: {
                                            "-translate-y-1 scale-75":
                                              _vm.isCollapsed
                                          }
                                        },
                                        _vm._l(promptBoxes, function(
                                          prompt,
                                          promptIdx
                                        ) {
                                          return _c("div", { key: promptIdx }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "relative flex items-center justify-center flex-shrink-0 cursor-pointer hover-darker",
                                                class: {
                                                  "h-12 w-12 xl:h-14 xl:w-14 rounded-xl":
                                                    _vm.sessionStatus ===
                                                    "draft",
                                                  "h-18 w-18 rounded-3xl":
                                                    _vm.sessionStatus !==
                                                    "draft",
                                                  "bg-teal-700":
                                                    prompt.id ===
                                                    _vm.currentTrial.prompt_id,
                                                  "bg-teal-100":
                                                    prompt.id !==
                                                    _vm.currentTrial.prompt_id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onChoosePrompt(
                                                      prompt
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("BlTextTitle3", {
                                                  class: {
                                                    "text-pure-white":
                                                      prompt.id ===
                                                      _vm.currentTrial
                                                        .prompt_id,
                                                    "text-teal-700":
                                                      prompt.id !==
                                                      _vm.currentTrial.prompt_id
                                                  },
                                                  attrs: {
                                                    text: prompt.abbreviation
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _vm.pageCount > 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-center h-3 gap-2"
                                    },
                                    _vm._l(_vm.pageCount, function(n, idx) {
                                      return _c("div", {
                                        key: idx,
                                        staticClass:
                                          "w-3 h-3 transition-all duration-300 rounded-full cursor-pointer",
                                        class: {
                                          "bg-slate-700": n === _vm.page,
                                          "bg-slate-400": n !== _vm.page
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onChangePage(n)
                                          }
                                        }
                                      })
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.display === "select-next-task"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col items-center content-center justify-center h-full",
                              class: {
                                "gap-4": !_vm.isCollapsed,
                                "gap-2": _vm.isCollapsed
                              }
                            },
                            [
                              Object.keys(_vm.resultsState).length > 1 ||
                              _vm.currentTrial.prompt_id
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center text-center",
                                      class: {
                                        "flex-col gap-1": !_vm.isCollapsed,
                                        "flex-row gap-2": _vm.isCollapsed
                                      }
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        staticClass: "text-slate-700",
                                        attrs: {
                                          text: _vm.currentTrialData.prompt.name
                                        }
                                      }),
                                      _vm._v(" "),
                                      !_vm.isCollapsed
                                        ? _c("BlTextTitle1", {
                                            staticClass: "text-teal-700",
                                            attrs: {
                                              text:
                                                _vm.currentTrialData.prompt
                                                  .score + "%"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isCollapsed
                                        ? _c("BlTextSubtitle3", {
                                            staticClass: "text-teal-700",
                                            attrs: {
                                              text:
                                                _vm.currentTrialData.prompt
                                                  .score + "%"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isCollapsed
                                        ? _c("BlInputButton", {
                                            attrs: {
                                              type: "plain",
                                              dense: "",
                                              label: "Change"
                                            },
                                            on: {
                                              clicked: function($event) {
                                                _vm.display = "select-prompt"
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col items-center gap-1 px-2"
                                },
                                [
                                  !_vm.isCollapsed
                                    ? _c(
                                        "div",
                                        { staticClass: "text-center" },
                                        [
                                          Object.keys(_vm.resultsState).length >
                                            1 || _vm.currentTrial.prompt_id
                                            ? _c("BlTextBody2", {
                                                attrs: { text: "Next" }
                                              })
                                            : _c("BlTextBody2", {
                                                attrs: {
                                                  text: "Select a task to start"
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: {
                                        "overflow-x-auto scrollbar-lg pb-2":
                                          _vm.isCollapsed
                                      },
                                      style: _vm.isCollapsed
                                        ? { maxWidth: "calc(100vw - 6rem)" }
                                        : {}
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center gap-2",
                                          class: {
                                            "justify-center flex-wrap": !_vm.isCollapsed
                                          }
                                        },
                                        _vm._l(_vm.ratioScores, function(
                                          taskCode
                                        ) {
                                          return _c("BlInputButton", {
                                            key: taskCode.id,
                                            attrs: {
                                              type:
                                                taskCode.id === _vm.nextTask.id
                                                  ? "teal"
                                                  : "outlined-teal",
                                              dense: "",
                                              label:
                                                taskCode.code +
                                                " | " +
                                                (taskCode.count + 1)
                                            },
                                            on: {
                                              clicked: function($event) {
                                                _vm.nextTask = taskCode
                                              }
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOpenProblemBehavior
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col items-center content-center justify-center w-full h-full",
                        class: {
                          "gap-4": _vm.isCollapsed,
                          "gap-2": !_vm.isCollapsed
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-wrap items-start content-center justify-center w-full gap-x-2 gap-y-3",
                            class: {
                              "-translate-y-1 scale-75": _vm.isCollapsed
                            }
                          },
                          _vm._l(_vm.SBTProblemBehaviors, function(
                            problemBehavior,
                            idx
                          ) {
                            return _c("div", { key: idx }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "relative flex items-center justify-center flex-shrink-0 cursor-pointer hover-darker",
                                  class: {
                                    "h-12 w-12 xl:h-14 xl:w-14 rounded-xl":
                                      _vm.sessionStatus === "draft",
                                    "h-18 w-18 rounded-3xl":
                                      _vm.sessionStatus !== "draft",
                                    "bg-tomato-700":
                                      problemBehavior.id ===
                                      _vm.currentTrial
                                        .target_problem_behavior_id,
                                    "bg-tomato-100":
                                      problemBehavior.id !==
                                      _vm.currentTrial
                                        .target_problem_behavior_id
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onChooseProblemBehavior(
                                        problemBehavior
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("BlTextTitle3", {
                                    class: {
                                      "text-pure-white":
                                        problemBehavior.id ===
                                        _vm.currentTrial
                                          .target_problem_behavior_id,
                                      "text-tomato-700":
                                        problemBehavior.id !==
                                        _vm.currentTrial
                                          .target_problem_behavior_id
                                    },
                                    attrs: { text: problemBehavior.code }
                                  })
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  _vm.currentTrialData.problem_behavior
                                    .code_definition
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isOpenTrialHistory && !_vm.isOpenEditTrial
            ? _c(
                "div",
                {
                  staticClass: "flex flex-col overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 32rem)" }
                },
                _vm._l(Object.keys(_vm.resultsState), function(key) {
                  return _c("div", { key: key }, [
                    _vm.resultsState[key].prompt_id
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-between px-2 py-3 border-b border-slate-300"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex-shrink-0 w-6" },
                                  [
                                    _c("BlTextBody2", {
                                      attrs: { text: key + "." }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("BlTextSubtitle3", {
                                      staticClass: "text-slate-700",
                                      attrs: {
                                        text: _vm.getCode(
                                          _vm.resultsState[key].target_task_id,
                                          "task_code"
                                        )
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _vm.resultsState[key].target_problem_behavior_id
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-center w-6 h-6 rounded bg-tomato-700"
                                      },
                                      [
                                        _c("BlTextSubtitle3", {
                                          staticClass: "text-pure-white",
                                          attrs: {
                                            text: _vm.getCode(
                                              _vm.resultsState[key]
                                                .target_problem_behavior_id,
                                              "problem_behavior"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-center w-6 h-6 bg-teal-700 rounded"
                                  },
                                  [
                                    _c("BlTextSubtitle3", {
                                      staticClass: "text-pure-white",
                                      attrs: {
                                        text: _vm.getCode(
                                          _vm.resultsState[key].prompt_id,
                                          "prompt"
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.sessionStatus !== "completed"
                                  ? _c("BlIcon", {
                                      staticClass: "w-5 h-5",
                                      attrs: {
                                        icon: "edit",
                                        color: "slate-8",
                                        clickable: ""
                                      },
                                      on: {
                                        clicked: function($event) {
                                          return _vm.onOpenEditTrial(key)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      : Object.keys(_vm.resultsState).length === 1
                      ? _c(
                          "div",
                          { staticClass: "py-4 text-center" },
                          [
                            _c("BlTextBody2", {
                              attrs: { text: "No result recorded yet." }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.isCollapsed || _vm.display === "select-next-task"
        ? _c(
            "div",
            {
              staticClass: "sticky w-full bg-pure-white",
              class: {
                "bottom-0": _vm.sessionStatus !== "draft",
                "-bottom-3 pb-3": _vm.sessionStatus === "draft"
              }
            },
            [
              _vm.isOpenProblemBehavior
                ? _c(
                    "div",
                    { staticClass: "flex-grow" },
                    [
                      _c("BlInputButton", {
                        staticClass: "w-full",
                        attrs: { type: "outlined", label: "Back to result" },
                        on: {
                          clicked: function($event) {
                            _vm.isOpenProblemBehavior = false
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm.isOpenTrialHistory && !_vm.isOpenEditTrial
                ? _c(
                    "div",
                    { staticClass: "flex-grow " },
                    [
                      _c("BlInputButton", {
                        staticClass: "w-full",
                        attrs: { type: "outlined", label: "Back" },
                        on: { clicked: _vm.onCloseTrialHistory }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between flex-shrink-0 gap-3"
                    },
                    [
                      !_vm.isOpenEditTrial && !_vm.isCollapsed
                        ? _c("BlInputButton", {
                            staticClass: "flex-shrink-0",
                            attrs: { type: "outlined", icon: "menu" },
                            on: { clicked: _vm.onOpenTrialHistory }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOpenEditTrial && !_vm.isCollapsed
                        ? _c("BlInputButton", {
                            staticClass: "flex-shrink-0",
                            attrs: { type: "outlined", icon: "menu" },
                            on: { clicked: _vm.onCloseEditTrial }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.nextTask.code &&
                      _vm.display === "select-next-task" &&
                      !_vm.isOpenEditTrial
                        ? _c(
                            "div",
                            { staticClass: "flex-grow" },
                            [
                              Object.keys(_vm.resultsState).length > 1 ||
                              _vm.currentTrial.prompt_id
                                ? _c("BlInputButton", {
                                    staticClass: "w-full",
                                    attrs: {
                                      type: "teal",
                                      label:
                                        "Next: " +
                                        _vm.nextTask.code +
                                        " | " +
                                        (_vm.nextTask.count + 1),
                                      loading: _vm.submitLoading
                                    },
                                    on: { clicked: _vm.onNextTrial }
                                  })
                                : _c("BlInputButton", {
                                    staticClass: "w-full",
                                    attrs: {
                                      type: "teal",
                                      label: "Start trial: " + _vm.nextTask.code
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.onTakeNextTrial({
                                          isNew: false
                                        })
                                      }
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isOpenEditTrial
                        ? _c(
                            "div",
                            { staticClass: "flex-grow" },
                            [
                              _c("BlInputButton", {
                                staticClass: "w-full",
                                attrs: {
                                  type: "teal",
                                  label: "Update",
                                  loading: _vm.submitLoading
                                },
                                on: { clicked: _vm.onSaveEditTrial }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      Object.keys(_vm.resultsState).length > 1 ||
                      _vm.currentTrial.prompt_id
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center w-10 h-10 rounded cursor-pointer hover-darker",
                              class: {
                                "bg-tomato-200": !_vm.currentTrial
                                  .target_problem_behavior_id,
                                "bg-tomato-700":
                                  _vm.currentTrial.target_problem_behavior_id
                              },
                              on: {
                                click: function($event) {
                                  _vm.isOpenProblemBehavior = true
                                }
                              }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                class: {
                                  "text-tomato-700": !_vm.currentTrial
                                    .target_problem_behavior_id,
                                  "text-pure-white":
                                    _vm.currentTrial.target_problem_behavior_id
                                },
                                attrs: {
                                  text:
                                    _vm.currentTrialData.problem_behavior.code
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e735cc2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e735cc2e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/SkillBasedTreatment.vue
// module id = null
// module chunks = 